const readTicketCartConfig = (root) => {
	const script = root.parentElement?.querySelector('[data-ticket-cart-config]') || document.querySelector('[data-ticket-cart-config]');
	try { return script ? JSON.parse(script.textContent) : null; } catch { return null; }
};

const postTicketCart = async (endpoint, payload) => {
	const response = await fetch(endpoint, {
		method: 'POST',
		headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
		body: JSON.stringify(payload),
	});
	const result = await response.json();
	if (!response.ok || result.error) throw new Error(result.errorMessage || 'Unable to update the order.');
	return result;
};

document.querySelectorAll('[data-ticket-cart]').forEach((root) => {
	const config = readTicketCartConfig(root);
	if (!config) return;
	const blocker = root.querySelector('[data-cart-blocker]');
	const message = root.querySelector('[data-cart-message]');
	const dialog = root.querySelector('[data-payment-dialog]');
	const paymentContent = root.querySelector('[data-payment-content]');
	let paymentLink = '';
	let orderId = '';
	let paymentTimer = null;

	const setBusy = (busy) => {
		root.classList.toggle('is-busy', busy);
		if (blocker) blocker.hidden = !busy;
	};
	const showMessage = (text) => {
		if (!message) return;
		message.textContent = text;
		message.hidden = !text;
	};
	const runAction = async (payload) => {
		setBusy(true);
		try {
			await postTicketCart(config.endpoint, payload);
			window.location.reload();
		} catch (error) {
			showMessage(error instanceof Error ? error.message : 'Unable to update the order.');
			setBusy(false);
		}
	};
	const cancelPayment = async () => {
		if (paymentTimer) window.clearInterval(paymentTimer);
		if (!orderId) { dialog?.close(); return; }
		setBusy(true);
		try { await postTicketCart(config.endpoint, {fn: 'cancelOrder', order: orderId}); }
		finally { window.location.reload(); }
	};
	const startPaymentTimer = () => {
		let seconds = 1200;
		paymentTimer = window.setInterval(() => {
			seconds -= 1;
			const timer = root.querySelector('#tim');
			if (timer) timer.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
			if (seconds <= 0) cancelPayment();
		}, 1000);
	};

	root.addEventListener('click', async (event) => {
		const remove = event.target.closest('[data-remove-ticket]');
		if (remove) {
			await runAction({fn: 'removeFromCart', id: Number(remove.dataset.removeTicket)});
			return;
		}
		if (event.target.closest('#clearcart')) {
			await runAction({fn: 'emptyCart'});
			return;
		}
		if (event.target.closest('#paymentprocess')) {
			if (!root.querySelector('#reg_1')?.checked) {
				showMessage(config.termsMessage);
				return;
			}
			showMessage('');
			setBusy(true);
			try {
				const result = await postTicketCart(config.endpoint, {fn: 'getMSUUrl', pib: ''});
				paymentLink = result.link || '';
				orderId = result.order || '';
				if (paymentContent) paymentContent.innerHTML = result.html || '';
				dialog?.showModal();
				startPaymentTimer();
			} catch (error) {
				showMessage(error instanceof Error ? error.message : 'Unable to start payment.');
			} finally { setBusy(false); }
		}
	});

	root.querySelector('[data-cancel-payment]')?.addEventListener('click', cancelPayment);
	root.querySelector('[data-confirm-payment]')?.addEventListener('click', () => {
		if (paymentLink) window.location.assign(paymentLink);
	});
	dialog?.addEventListener('cancel', (event) => { event.preventDefault(); cancelPayment(); });

	if (Number(config.expiresIn) > 0) window.setTimeout(() => window.location.reload(), Number(config.expiresIn) * 1000);
});
